import React, { useState } from "react";
import Layout from "../../component/Layout";
import { Header } from "../../component/Header";
import event1 from "../../images/event1.svg";
import intensity from "../../images/intensity.svg";
import goalTime from "../../images/goalTime.svg";
import distance1 from "../../images/distance.svg";
import greaterWhite from "../../images/greaterWhite.svg";
import clockBlack from "../../images/clockBlack.svg";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
export const Split: React.FC = () => {
  const [item, setItem] = useState("");
  const [distance, setDistance] = useState("distance");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDistanceDropdown, setShowDistanceDropdown] = useState(false);

  const marks = {
    70: "70",
    75: "75",
    80: "80",
    85: "85",
    90: "90",
    95: "95",
    100: "100",
  };
  const itemOptions = ["Pace", "Accuracy", "Focus"];
  const distanceOptions = ["distance", "pace", "Focus"];

  return (
    <Layout>
      <div className="bg-black h-dvh relative pb-3">
        <Header />
        <div className="w-full max-w-2xl mx-auto shadowbg px-5">
          <div className="text-center relative roundedLineBreaK min-h-[150px] pt-4 mb-8 mt-5">
            <div className="mt-18">
              <p className="text-white text-[48px] font-normal leading-none mb-[5px]  split-1">
                6.86s
              </p>
              <span className="text-white text-[12px] font-normal !leading-none">
                TARGET TIME
              </span>
            </div>
            <div className="w-fit px-5 block mx-auto relative -bottom-12 bg-black max-[389px]:-bottom-2 left-1/2 -translate-x-1/2 split-2">
              <p className="text-white text-[28px] font-medium leading-[95%]">
                99%
              </p>
              <span className="text-white text-[10px] font-normal leading-[95%]">
                PERFORMANCE
              </span>
            </div>
          </div>
          {/* slider here */}
          <div className="my-7">
            <div className="flex flex-row items-center gap-[10px] pl-3">
              <img src={intensity} alt="icon" className="object-contain" />
              <p className="text-white text-base font-normal tracking-[-0.408px]">
                85% Intensity
              </p>
            </div>
            <div style={{ padding: "10px", background: "#000", color: "#fff" }}>
              <Slider
                allowCross={false}
                step={5}
                min={70}
                max={100}
                defaultValue={85}
                marks={marks}
                trackStyle={{
                  backgroundColor: "red",
                  height: 6,
                }}
                handleStyle={{
                  borderColor: "#fff",
                  opacity: "1",
                  height: 14,
                  width: 14,
                  backgroundColor: "#fff",
                }}
                railStyle={{
                  backgroundColor: "gray",
                  height: 6,
                }}
                dotStyle={{
                  borderColor: "black",
                  backgroundColor: "black",
                  borderRadius: "0px",
                  height: "6px",
                  width: "2px",
                }}
                activeDotStyle={{
                  borderColor: "red",
                }}
                style={{
                  marginBottom: "20px",
                }}
              />
            </div>
          </div>
          {/* __________________ */}
          <div className="flex flex-col gap-4">
            <div className="flex gap-[12px]">
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img src={event1} alt="icon" className="object-contain w-4" />
                <div
                  className="relative cursor-pointer"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <p className="text-white text-sm font-normal leading-none mb-3 capitalize">
                    Event/{item}
                  </p>
                  <img
                    src={greaterWhite}
                    alt="icon"
                    className={`object-contain w-3 ${
                      showDropdown ? "rotate-180" : "rotate-0"
                    }`}
                  />
                  {showDropdown && (
                    <ul className="absolute top-full h-fit -left-3 w-full min-w-full border border-white/20 focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                      {itemOptions.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setItem(option);
                            setShowDropdown(false);
                          }}
                          className="px-2 py-1 text-xs text-white hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img src={goalTime} alt="icon" className="object-contain w-4" />
                <input
                  type="text"
                  className="text-white text-base font-normal leading-none border-b border-white bg-transparent py-1 placeholder:text-white"
                  placeholder="Goal Time"
                />
              </div>
              <div className="w-1/3 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3">
                <img
                  src={distance1}
                  alt="icon"
                  className="object-contain h-4 w-4"
                />
                <div
                  className="relative cursor-pointer"
                  onClick={() => setShowDistanceDropdown(!showDistanceDropdown)}
                >
                  <p className="text-white text-sm font-normal leading-none capitalize mb-3">
                    {distance}
                  </p>
                  <img
                    src={greaterWhite}
                    alt="icon"
                    className={`object-contain w-3 ${
                      showDistanceDropdown ? "rotate-180" : "rotate-0"
                    }`}
                  />
                  {showDistanceDropdown && (
                    <ul className="absolute top-full h-fit -left-3 w-full min-w-full border border-white/20 focus:outline-none rounded-[10px] bg-black text-white mt-2 shadow-lg z-10">
                      {distanceOptions.map((option) => (
                        <li
                          key={option}
                          onClick={() => {
                            setDistance(option);
                            setShowDistanceDropdown(false);
                          }}
                          className="px-2 py-1 text-xs text-white hover:bg-gray-900 cursor-pointer rounded-[10px] overflow-hidden"
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-row gap-[10px]">
              <div className="w-1/2 min-h-[80px] border border-white/10 rounded-[15px] py-4 px-3 flex flex-col gap-3 mr-1">
                <img
                  src={clockBlack}
                  alt="icon"
                  className="object-contain w-4"
                />
                <input
                  type="text"
                  className="text-white text-base font-normal leading-none border-b border-white bg-transparent py-1 placeholder:text-white"
                  placeholder="Actual Time"
                />
              </div>
              <button className="w-1/4 min-h-[80px] bg-[#171717] rounded-[15px] text-white/40 p-[16px_15px] flex flex-col justify-center items-center text-center uppercase text-[10px] font-normal">
                reset
              </button>
              <button className="w-1/4 min-h-[80px] bg-white rounded-[15px] p-[16px_15px] text-center flex flex-col justify-center items-center">
                <span className="bg-black w-[30px] h-px block mb-[15px]"></span>
                <span className="bg-black w-[30px] h-px block"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
